export default {"src":"/_next/static/media/step-pay.f860a8b3.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};